module.exports = __webpack_public_path__ + "autoalert-logo-ford-canada.d7930662a7451876f0b5.png";